import './brand-overview.scss'

/**
 * Brand Overview - Viewport Scroll Animation
 * Triggers hover effects on mobile when cards scroll into viewport
 */
const initBrandOverviewScroll = () => {
	const sections = document.querySelectorAll('.o-brandOverview');

	sections.forEach((section) => {
		const cards = section.querySelectorAll('.m-cardWithBlob__blob');

		if (cards.length === 0) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('-inViewport');
					} else {
						entry.target.classList.remove('-inViewport');
					}
				});
			},
			{
				root: null,
				rootMargin: '-20% 0px -20% 0px', // Trigger when element is 20% into viewport
				threshold: 0
			}
		);

		cards.forEach((card) => {
			observer.observe(card);
		});
	});
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initBrandOverviewScroll);
} else {
	initBrandOverviewScroll();
}
